import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtilsV2 } from '@shared/utils';
import { DashboardApi, RequestStrategyEnum, WithSignal, type DashboardSummariesResponse } from '@shared/api';

const getAccountSummaryEffect = createEffect(({ signal }: WithSignal = {}) => DashboardApi.getAccountSummary(signal));
const clearEvent = createEvent();

const $dataStore = createStore<DashboardSummariesResponse[]>([])
  .on(getAccountSummaryEffect.done, (_, data) => data.result.data ?? [])
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getAccountSummaryEffect.pending, (_, data) => data)
  .on(getAccountSummaryEffect.fail, (_, data) => ApiUtilsV2.abortApiLoadingFailCaseTrigger(data.error))
  .on(getAccountSummaryEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getAccountSummaryEffect, () => null)
  // .on(getAccountSummaryEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getAccountSummaryEffect.fail, () => 'Something went wrong while fetching Accounts Summary. Please try again.')
  .on(getAccountSummaryEffect.done, () => null)
  .reset(clearEvent);

const getAccountSummaryApi = ApiUtilsV2.wrapperApi(getAccountSummaryEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getAccountSummaryApi.cancel());

export const $dashboardAccountSummaryStore = {
  events: {
    getAccountSummary: getAccountSummaryApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
